module.exports = __webpack_public_path__ + "static/media/icon-hammer-green.0d5e0ec8.svg";